<template>
  <div class="mt-1">
    <div
      v-if="userPackage===null"
      class="text-danger"
    >
      {{ $t('companyProfilePackageStatus.paketSeimiEdilmyib') }}
    </div>
    <div
      v-else-if="userPackage.status === 'ACTIVE'"
      class="text-success"
    >
      {{ $t('companyProfilePackageStatus.userpackagepacknamePaket', {packageName: userPackage.pack.name}) }} <span
        v-if="userPackage.trial"
      >(Sınaq müddəti)</span> <br>
      <span v-if="userPackage.card===null">
        {{ $t('companyProfilePackageStatus.gnSonraBitir', {daysToExpire: daysToExpire}) }}
      </span>
      <span v-else>
        {{ $t('companyProfilePackageStatus.gnSonraYenilnck', {daysToExpire: daysToExpire}) }}
      </span>
    </div>
    <div
      v-else-if="userPackage.status=== 'EXPIRED'"
      class="text-warning"
    >
      {{ $t('companyProfilePackageStatus.paketinMddtiGnNcBitib', {expr: -daysToExpire}) }}
    </div>

    <div
      v-else-if="userPackage.status=== 'CANCELED'"
      class="text-danger"
    >
      {{ $t('companyProfilePackageStatus.paketLvEdilib') }}
      <span v-if="daysToExpire>0"> {{
        $t('companyProfilePackageStatus.nvbtiGnRzindPaketinQalmLimitlrindnIstifadEdBilrsin', {daysToExpire: daysToExpire})
      }} </span>
    </div>

    <div
      v-else
      class="text-primary"
    >
      {{ $t('companyProfilePackageStatus.paketStatusu', {status: userPackage.status}) }}
    </div>
  </div>
</template>
<script>

import moment from "moment";

export default {
  name: 'CompanyProfilePackageStatus',
  props: {
    userPackage: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    daysToExpire() {
      let duration = moment.duration(moment(this.userPackage.expirationTime).diff(moment()));
      return Math.round(duration.asDays());
    }
  }
}
</script>
